export default {"src":"/_next/static/media/arr_icon.6c4b2d76.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};